import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountManagementService } from '../../services/account-management.service';
import { LicensesEnum } from '../../../../api/monitoring/licenses.enum';
import { sublicenseDefaultValue, sublicenseMap, SublicensesEnum } from '../../../../api/monitoring/sublicenses.enum';
import { Sublicenses, SubscriptionLicenses } from '../../models/monitoring.configs.model';

@Component({
    selector: 'agpr-providers-preferences',
    templateUrl: './providers-preferences.component.html',
    styleUrls: ['./providers-preferences.component.scss'],
    standalone: false
})
export class ProvidersPreferencesComponent implements OnDestroy, OnInit {

    @Input() displayFinancialTimesPodcastUpsell: boolean = false;

    @Output() licensesChanged: EventEmitter<void> = new EventEmitter();

    subscriptions: Subscription[] = [];


    // eslint-disable-next-line @typescript-eslint/naming-convention
    readonly LicensesEnum = LicensesEnum;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    readonly SublicensesEnum = SublicensesEnum;


    licenses: SubscriptionLicenses;
    sublicenses: Sublicenses;

    burrellesAccountIds: string[];
    csSupplemental: boolean = false; // including both Snapshot(28) and CSV(35)

    isReadOnly: boolean = false;

    constructor(
        public accountManagementService: AccountManagementService
    ) { }


    ngOnInit(): void {
        this.subscriptions = [];
        this.subscriptions.push(
            this.accountManagementService.getLicenses().subscribe(x => {
                this.licenses = x;
                this.csSupplemental = x?.[LicensesEnum.SNAPSHOT] && x?.[LicensesEnum.CSV];
            }),
            this.accountManagementService.getSublicenses().subscribe(x => this.sublicenses = x),
            this.accountManagementService.getReadOnly().subscribe(x => this.isReadOnly = x),
            this.accountManagementService.getBurrellesAccountIds().subscribe(x => this.burrellesAccountIds = x),
        );
    }

    handleLicenseChange() {
        this.licensesChanged.emit();
    }

    handleCsSupplementalChange(checked: boolean) {
        this.licenses[LicensesEnum.SNAPSHOT] = this.licenses[LicensesEnum.CSV] = checked;
    }

    handleLicenseChangeWithSublicenses() {
        for (const sublicenseId of Object.values(SublicensesEnum)) {
            const license = sublicenseMap.get(sublicenseId as SublicensesEnum);
            this.sublicenses[sublicenseId] = this.licenses[license] && sublicenseDefaultValue.get(sublicenseId as SublicensesEnum);
        }
        this.refMediaSublicenseChange();
    }

    refMediaSublicenseChange() {
        this.accountManagementService.refMediaSublicenseChange();
        this.licenses[LicensesEnum.REFMEDIA] = this.sublicenses[SublicensesEnum.REFMEDIA_ONLINE_PRINT] ||
                                                this.sublicenses[SublicensesEnum.REFMEDIA_PARLIAMENTARY] ||
                                                this.sublicenses[SublicensesEnum.REFMEDIA_BROADCAST];
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    burrellesAccountIdsChange(ids: string[]) {
        this.burrellesAccountIds = ids.map(id => id?.trim());
        this.accountManagementService.setBurrellesAccountIds(this.burrellesAccountIds);
    }
}
